import { useAppContext } from "@src/autoDebit/AppContext";
import styles from "./textInput.module.css";
import commonStyles from "../common.module.css";
import Title from "../Title";

export interface ITextInputProps extends AutoDebit.IFormField {
  title: TranslateDescriptor;
  placeholder?: TranslateDescriptor;
  disabled?: boolean;
  style?: React.CSSProperties;
  autoComplete?: string;
  name?: string;
}

const TextInput = ({
  title,
  placeholder,
  onChange,
  value,
  id,
  errorComponent,
  disabled,
  style,
  autoComplete,
  name,
}: ITextInputProps) => {
  const { intl } = useAppContext();
  return (
    <fieldset className={commonStyles.wrap} key={id} style={style} data-id={id}>
      <Title text={title}></Title>
      <div className={commonStyles.action}>
        <input
          className={styles.input}
          type="text"
          value={value}
          disabled={disabled}
          autoComplete={autoComplete}
          name={name}
          {...(placeholder && {
            placeholder: intl.formatMessage(placeholder),
          })}
          onChange={(e: React.FormEvent<HTMLInputElement>) => {
            onChange && onChange(e.currentTarget.value);
          }}
        />
        {errorComponent && errorComponent()}
      </div>
    </fieldset>
  );
};

export default TextInput;
